import { Fragment } from "react/jsx-runtime"
import { title } from "@/components/primitives";
import DefaultLayout from "@/layouts/default";

const AdminMeetingsPage = () => {
return (<DefaultLayout>
    <h2>Admin Meetings Page</h2>
</DefaultLayout>)
}

export default AdminMeetingsPage